<template>
  <div class="BSCSteppers">
    <div
      class="BSCSteppers-step"
      v-for="(step, index) in listSteps"
      :key="index"
      :class="[`is-${type}`, { 'is-active': step.isActive }]"
    >
      <svg
        v-if="step.pos !== 0"
        :class="[{ 'is-onlyStep': isOnlyStep }]"
        width="20"
        height="3"
        viewPort="0 0 0 0"
        version="1.1"
      >
        <line
          x1="0"
          y1="0"
          x2="20"
          y2="0"
          stroke-width="3"
          stroke-linecap="square"
        />
      </svg>
      <span
        class="BSCSteppers-step-label"
        :class="[
          { 'is-clickable': isClickable },
          { 'is-current': currentStep == step.pos }
        ]"
        @click="changeStep(step.pos)"
        >{{ step.label }}</span
      >
    </div>
  </div>
</template>

<script>
'use strict'

export default {
  name: 'BSCSteppers',
  inheritAttrs: false,
  props: {
    steps: {
      type: Array,
      default: () => []
    },
    value: {
      type: [String, Number],
      default: 0
    },
    type: {
      type: String,
      default: ''
    },
    isClickable: {
      type: Boolean,
      default: false
    },
    isOnlyStep: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: this.value
    }
  },
  methods: {
    changeStep(newPos) {
      if (this.isClickable) this.$emit('input', newPos)
    }
  },
  computed: {
    listSteps() {
      return this.steps.map((s, index) => {
        return {
          pos: index,
          label: s,
          isActive:
            (index <= this.currentStep && !this.isOnlyStep) ||
            index == this.currentStep
        }
      })
    }
  },
  watch: {
    value(newValue) {
      this.currentStep = newValue
    },
    currentStep(newCurrentStep) {
      this.$emit('input', newCurrentStep)
    }
  }
}
</script>
